import type { KaannosAvain } from "./kaannokset";

/* ═══ Vironkieliset käyttöliittymätekstit (et) — Toni 18.10.2026 klo 12.45 «Viro kenttäkieleksi, aloita nyt» ═══
   Laajuus: kenttäkäyttäjän näkymät (kirjautuminen, hitsausistunto, hitsin kirjaus, oma lista, punch, linjatarkastus), samaan
   malliin kuin liettua. Muuta käyttöliittymää ei käännetä nyt. Valittavissa vain instanssissa, jonka KIELET sisältää et:n.
   KONEKÄÄNNÖS: jokainen rivi on «tarkistamatta», kunnes virolainen tarkistaja merkitsee sen Käännökset-näkymässä. Alan termit
   käännetään vain Tonin hyväksymällä termiluettelolla (C:\Sampo-STAGING\Viro_termit_2026-10-18.md), niitä ei arvata.
   Puuttuva rivi näytetään englanniksi (varakieli, Toni 11.10.2026). Yksi totuus: tämä tiedosto. */
export const ET: Partial<Record<KaannosAvain, string>> = {
  "hl.alinumero": "Alamnumber",
  "hl.aloita_kirjaus": "Alusta registreerimist",
  "hl.anna_numero": "Sisesta keevise number.",
  "hl.asentaja": "Torumontöör",
  "hl.asetetaan_kerran": "Seadistatakse üks kord — pärast seda on iga keevis üks puudutus",
  "hl.avaa_linja": "Ava liin",
  "hl.ei_hitsaajia": "Ühelgi isikul pole oskust Keevitaja. Lisa see vaates Personal, muidu keevitajat valida ei saa.",
  "hl.ei_isometria": "isomeetria puudub",
  "hl.ei_isometria_selite": "Sellel liinil pole isomeetriat, seega lehte pole ja keevised nummerdatakse liini kaupa järjest. Puudus registreeritakse ja seda näidatakse koos vastutajaga vaates Puudused.",
  "hl.ei_oikeutta": "Keeviseid ei ole lubatud registreerida",
  "hl.ei_oikeutta_selite": "Keeviste registreerimiseks on vaja keevitaja, töödejuhataja või planeerija õigusi.",
  "hl.ei_osumia": "Vasteid ei leitud:",
  "hl.ei_tehda": "Keevis pole vajalik",
  "hl.ei_tehda.esitys": "Ettepanek registreeritud. Töödejuhataja kinnitab kande.",
  "hl.ei_tehda.merkitty": "Märgitud: keevis pole vajalik.",
  "hl.ei_tehda.selite": "Märgi, et keevisõmblust ei keevitata üldse. Töödejuhataja kinnitab kande.",
  "hl.ei_tyomaata": "Sa ei näe ühtegi objekti: {peruste}.",
  "hl.esim_316l": "nt 316L",
  "hl.esivalinta_ei_loydy": "Liini {linja} ei leitud — seda pole olemas või see kuulub objektile, mida sa ei näe.",
  "hl.esivalinta_monta": "Liin {linja} on olemas {n} objektil. Vali liin loendist.",
  "hl.haetaan_vapaata": "otsitakse järgmist vaba numbrit…",
  "hl.halkaisijatuumaa": "läbimõõdu tolli",
  "hl.havaittu_sitten": "tuvastatud {n} p tagasi",
  "hl.havaittu_tanaan": "tuvastatud täna",
  "hl.hitsaaja": "Keevitaja",
  "hl.hitsi": "Keevis",
  "hl.hitsia_tanaan": "keevist täna",
  "hl.jatka_edellista": "Jätka eelmist päeva {pvm} ({n} p tagasi)",
  "hl.jatka_mista_jait": "Jätka sealt, kus pooleli jäi",
  "hl.jo_kirjattu": "Juba registreeritud",
  "hl.johdettu_isometrista": "tuletatud isomeetriast ({mitta})",
  "hl.jumissa": "Mis on blokeeritud",
  "hl.jumissa_jarjestys": "Blokeerivad esimesena, seejärel vanimad",
  "hl.jumissa_tyhja": "Mis on blokeeritud: mitte midagi — avatud puudusi pole.",
  "hl.kenelle_ja_mihin": "Kes ja kuhu",
  "hl.kirjaa_hitsi": "Registreeri keevis {numero}",
  "hl.kirjataan": "Registreeritakse…",
  "hl.kirjataan_paivalle": "Registreeritakse kuupäevale",
  "hl.kirjaus_ei_onnistunut": "Registreerimine ebaõnnestus.",
  "hl.kirjoita_linjan_alku": "Kirjuta liini algus, näiteks",
  "hl.kohde_pieni": "objekt",
  "hl.kohderistiriita": "Sessiooni liin {linja} on objektil {kohde}, kuid valitud on objekt {valittu}. Registreerimine on blokeeritud: vaheta liin («Vaheta liin») või vali objekt {kohde}.",
  "hl.koodi_ei_listalla": "Sinu kood {koodi} pole keevitajate loendis (oskus Keevitaja puudub). Keevis registreeritakse sinu koodiga, kuid kvalifikatsiooni kontroll ei tunne sind keevitajana. Palu töödejuhatajal oskus lisada.",
  "hl.korjaa": "Muuda",
  "hl.korjaa_istunnosta": "paranda see sessiooni seadetes (Vaheta liin).",
  "hl.kuvat_hitsi": "Fotod · keevis {nro}",
  "hl.kuvat_n": "Fotod ({n})",
  "hl.laji.A": "Paigaldus",
  "hl.laji.E": "Eelvalmistus",
  "hl.laji.R": "Parandus",
  "hl.laji.S": "S",
  "hl.lehti": "Leht",
  "hl.lehti_pakollinen": "Leht on kohustuslik: nummerdus on lehe kaupa ja ilma selleta sulaksid samad keevisenumbrid eri lehtedel kokku.",
  "hl.lehti_pieni": "leht",
  "hl.linja": "Liin",
  "hl.linja_poistunut": "Liini {linja} pole enam olemas — sessioon suleti.",
  "hl.lisaa_kuva": "+ Foto",
  "hl.lisaaine": "Lisametall",
  "hl.materiaali": "Materjal",
  "hl.materiaali_molemmat": "Materjal (mõlemad detailid)",
  "hl.materiaali_pakollinen": "Materjal on kohustuslik: ainult sulami number ei ütle, mis materjal see on, ja materjalisertifikaati ei saa ilma selleta vastavusse viia.",
  "hl.mille_paivalle": "Millise kuupäeva kohta registreerid?",
  "hl.mina": "mina",
  "hl.muu": "Muu…",
  "hl.muu_kirjoita": "Muu (kirjuta)…",
  "hl.muu_paiva": "Muu kuupäev…",
  "hl.n_hitsia": "{n} keevist",
  "hl.n_viimeisinta": "{n} viimast",
  "hl.nimike": "Nimetus",
  "hl.nimike_pieni": "nimetus",
  "hl.nimike.kartio": "Koonus",
  "hl.nimike.kayra": "Põlv",
  "hl.nimike.laippa": "Äärik",
  "hl.nimike.putki": "Toru",
  "hl.nimike.supistus": "Üleminek",
  "hl.nimike.t_haara": "T-haru",
  "hl.nimike.tulppa": "Kork",
  "hl.nimike.venttiili": "Ventiil",
  "hl.ohje.kuka": "Registreerid oma keevised. Alamnumbriga keevis (nt 6.1) on objektil tehtud lisandus: see salvestatakse kohe ja jääb töödejuhatajale kinnitamiseks — see ei peata tööd.",
  "hl.ohje.numerot": "Täisarv (6) on planeeritud keevis. Alamnummerdus algab x.1-st: keeviste 6 ja 7 vahele tulevad 6.1, 6.2 jne — mitte kunagi 7.x. Enne keevist 1 kasuta 0.1, 0.2 jne. Kasutatud alamnumbrit ei kasutata kunagi uuesti, isegi kui keevis kustutati.",
  "hl.ohje.numerot_otsikko": "Keevisenumbrid",
  "hl.omat_viimeisimmat": "Sinu viimased liinid",
  "hl.omia_hitseja_tanaan": "oma keevist täna",
  "hl.omia_tuumia": "oma läbimõõdu tolli",
  "hl.osa_n": "Detail {n}",
  "hl.osa_n_pieni": "detail {n}",
  "hl.osat_ja_sulatukset": "Detailid ja sulami numbrid",
  "hl.paiva": "Kuupäev",
  "hl.perustiedot_virhe": "Põhiandmeid ei õnnestunud laadida.",
  "hl.peruuta": "Tühista",
  "hl.prosessi": "Protsess",
  "hl.punakyna.esim": "nt tugi nihutatud",
  "hl.punakyna.miksi": "Miks see keevis tehti",
  "hl.punakyna.selite": "{numero} on alamnumber ehk objektil tehtud lisandus. See salvestatakse kohe ja jääb töödejuhatajale kinnitamiseks — see ei peata tööd.",
  "hl.puutetta_auki": "avatud puudust",
  "hl.seuraava_vapaa": "järgmine vaba {nro}",
  "hl.sulatukset": "Sulami numbrid",
  "hl.sulatukset_periytyvat": "Sulami numbrid kanduvad keeviselt keevisele. Muuda neid, kui toru vahetub — see on ainus koht, kus jälgitavus katkeb, kui see ununeb.",
  "hl.sulatus": "Sulami nr",
  "hl.sulatus_kylla": "Jah, sama",
  "hl.sulatus_kysy": "Sama sulami number kui eelmisel keevisel?",
  "hl.sulatus_kysy.kirjaaja": "Eelmise keevise registreeris teine konto.",
  "hl.sulatus_kysy.lehti": "Leht on muutunud.",
  "hl.sulatus_kysy.linja": "Liin on muutunud.",
  "hl.sulatus_kysy.tauko": "Eelmisest registreerimisest on möödunud üle {h} tunni.",
  "hl.sulatus_puuttuu": "sulami number puudub",
  "hl.sulatus_puuttuu_merkitty": "sulami number puudub, registreeritud puudusena",
  "hl.sulatusnumero": "sulami number",
  "hl.sulje": "Sulge",
  "hl.suunnitellut": "Planeeritud — puuduta täitmiseks",
  "hl.suunniteltu_title": "Planeeritud keevis — täida tähis + kuupäev",
  "hl.tanaan": "Täna",
  "hl.tarkista_kirjoitusasu": "Kontrolli kirjapilti või vali Kõik objektid.",
  "hl.tarra": "Silt",
  "hl.tarra_muoto": "Kleebis on 4 numbrit, nt 7049.",
  "hl.teko.kirjattu": "registreeritud",
  "hl.teko.taydennetty": "täidetud (planeeritud → keevitatud)",
  "hl.teko.toisto": "oli juba eelmise saatmisega salvestatud — teist rida ei loodud",
  "hl.tyomaa_allokaatiosta": "Objekt {tunnus} valiti sinu tööjaotuse põhjal ({peruste}). Muuda, kui oled mujal.",
  "hl.tyonjohdon_tuloste": "Töödejuhataja väljatrükk",
  "hl.ulkoinen": "väline",
  "hl.vaihda": "Vaheta",
  "hl.vaihda_linja": "Vaheta liin",
  "hl.vaihe.asennettu": "Paigaldatud {pvm} / {koodi} — etapp registreeritakse üks kord. Märgi parandus parandusena (R).",
  "hl.vaihe.asennus": "paigaldus",
  "hl.vaihe.esivalmiste": "eelvalmistus",
  "hl.vaihe.esivalmistettu": "Eelvalmistatud {pvm} / {koodi} — registreeritakse paigaldusena",
  "hl.vaihe.lisatty": "registreeritud, etapp {vaihe} (sama keevisõmblus)",
  "hl.vain_pari": "Keevitussessiooni saab alustada ainult keevitaja. Oled keevitaja paariline: keevitaja alustab registreerimist ja valib sind väljale «Torumontöör». Kui keevitad, palu töödejuhatajal lisada sulle keevitaja töö liik.",
  "hl.valitse": "Vali",
  "hl.valitse_viivat": "— vali —",
  "hl.valitusta_kohteesta": "valitud objektilt",
  "hl.vapaana_valissa": "Vaba vahepeal",
  "hl.vastuu_avoin": "vastutaja puudub",
  "hl.viimeksi_kirjatut": "Viimati registreeritud",
  "hl.virallinen_loki": "Ametlik keevituspäevik",
  "hl.vp.ke": "Kolmapäev",
  "hl.vp.la": "Laupäev",
  "hl.vp.ma": "Esmaspäev",
  "hl.vp.pe": "Reede",
  "hl.vp.su": "Pühapäev",
  "hl.vp.ti": "Teisipäev",
  "hl.vp.to": "Neljapäev",
  "hoito.osoitti": "määras {nimi}",
  "iv.poytakirja": "Protokolli nr",
  "kirjautuminen.ei_yhteytta": "Serveriga ei õnnestunud ühendust saada.",
  "kirjautuminen.istunto_vanhentui": "Sinu sessioon aegus — logi uuesti sisse. Andmeid pole kadunud.",
  "kirjautuminen.kenttatili": "Välitöö konto",
  "kirjautuminen.kenttatilille": "Logi sisse välitöö kontoga →",
  "kirjautuminen.kirjaudu": "Logi sisse",
  "kirjautuminen.kirjaudutaan": "Sisselogimine…",
  "kirjautuminen.koodi": "Töötaja kood",
  "kirjautuminen.koodi_esim": "nt JKo",
  "kirjautuminen.pin": "PIN",
  "kirjautuminen.sahkoposti": "E-post",
  "kirjautuminen.sahkopostilla": "← Logi sisse e-postiga",
  "kirjautuminen.salasana": "Parool",
  "kirjautuminen.unohtunut": "Unustasid parooli?",
  "kirjautuminen.unohtunut_laheta": "Saada link",
  "kirjautuminen.unohtunut_lahetetty": "Kui aadress on kasutusel, saadeti sellele parooli lähtestamise link. Link kehtib ühe tunni ja töötab ühe korra. Kontrolli ka rämpsposti kausta.",
  "kirjautuminen.unohtunut_ohje": "Sisesta oma konto e-posti aadress. Saadame lingi uue parooli määramiseks. Välitöö konto PIN-koodi lähtestab administraator.",
  "kirjautuminen.unohtunut_otsikko": "Lähtesta parool",
  "kirjoitusohje.korjaava": "Kirjuta nii, et parandaja aru saaks.",
  "kohde.kaikki": "Kõik objektid",
  "kuittaus.kohde": "Objekt",
  "kuittaus.rajain_media": "Keskkond",
  "kuittaus.vaihe": "Etapp",
  "lataus.kohteet": "Objektide laadimine ebaõnnestus",
  "lataus.kohteet_henkilot": "Objektide ja isikute laadimine ebaõnnestus",
  "lataus.ladataan": "Laadimine…",
  "lataus.osaamisluokat": "Oskusklasside laadimine ebaõnnestus",
  "lataus.yrita": "Proovi uuesti",
  "liite.poista": "Kustuta",
  "liite.poisto_virhe": "Kustutamine ebaõnnestus.",
  "ltar.a_punchit": "Liinil on {n} avatud A-klassi punchi (takistavad survekatset). Liini ülevaatus nõuab nende parandamist või kõrvalekalde registreerimist.",
  "ltar.allekirjoitettu_isometri": "Allkirjastatud isomeetria",
  "ltar.avaa_uudelleen": "Ava uuesti (tühista kinnitus)",
  "ltar.edustaja": "Tellija esindaja",
  "ltar.edustaja_pieni": "tellija esindaja",
  "ltar.ei_aloitettu": "Alustamata",
  "ltar.ei_tarkastettu": "üle vaatamata",
  "ltar.hitsi_ei_loydy": "Keevist «{h}» ei leitud sellelt liinilt üheselt.",
  "ltar.huomio": "märkus",
  "ltar.huomiot": "Märkused",
  "ltar.hyvaksy": "Kinnita liini ülevaatus",
  "ltar.hyvaksy_title": "Kinnita liini ülevaatus: liin on valmis NDT-ks ja survekatseks",
  "ltar.hyvaksyja": "kinnitaja",
  "ltar.hyvaksytty": "Kinnitatud",
  "ltar.isometri_puuttuu": "Manus puudub.",
  "ltar.k71": "Vastavus joonistele",
  "ltar.k72": "Keevitus ja NDT",
  "ltar.k73": "Materjalid ja komponendid",
  "ltar.k74": "Torutoed ja kinnitused",
  "ltar.k75": "Kalded, õhutus ja tühjendus",
  "ltar.k76": "Äärik- ja poltühendused",
  "ltar.k77": "Puhtus ja pinnatöötlus",
  "ltar.k78": "Katseseadistuse valmisolek",
  "ltar.k79": "Märgistused",
  "ltar.kesken": "Pooleli",
  "ltar.ladataan": "Laadimine…",
  "ltar.lahteen_poytakirja": "allika protokoll",
  "ltar.lisaa_poytakirja": "Lisa protokoll",
  "ltar.luokittelemattomia": "Sellel liinil on {n} avatud punchi ilma takistusklassita. Need ei takista kinnitamist, kuid pole teada, mida need takistavad.",
  "ltar.luovutettu": "Üle antud",
  "ltar.luovuttaja": "üle andis",
  "ltar.luovutus": "Tellija esindaja",
  "ltar.luovutus_ohje": "Liini ülevaatusel käiakse liin läbi koos tellija esindajaga, valmis survekatseks. Kinnitaja on sinu sisselogitud konto.",
  "ltar.luovutuspaiva": "Üleandmise kuupäev",
  "ltar.merkinta_hitsi": "keevis: nr või silt (tühi = kogu punkt)",
  "ltar.merkinta_kohta": "kogu punkt",
  "ltar.merkinta_korjattu": "parandatud",
  "ltar.merkinta_lisaa": "+ lisa uus",
  "ltar.merkinta_peru": "Tühista",
  "ltar.merkinta_tallenna": "Lisa punch",
  "ltar.nayta_punchit": "Näita punche",
  "ltar.nimi": "nimi",
  "ltar.otsikko": "Liini ülevaatus (walkdown)",
  "ltar.paneeli_luokaton": "klassita",
  "ltar.paneeli_nasta": "isomeetria märk {n}",
  "ltar.paneeli_otsikko": "Liini avatud punchid ({n})",
  "ltar.paneeli_tyhja": "Liinil pole avatud punche.",
  "ltar.poikkeama_kirjattu": "Kõrvalekalle: {n} avatud A-klassi punchi",
  "ltar.poikkeama_oikeus": "Kõrvalekalde saab registreerida ainult konto, millel on selle objekti õigus «Punchi kõrvalekalle».",
  "ltar.poikkeaman_syy": "Kõrvalekalde põhjus (registreeritakse sinu nimele)",
  "ltar.poytakirja": "Ülevaatuse protokoll",
  "ltar.poytakirja_vihje": "Lisa ülevaatuse protokoll fotona või PDF-ina.",
  "ltar.pvm": "Kuupäev",
  "ltar.sharepointissa": "Selles instantsis registreeritakse liini ülevaatus SharePointis (liini ülevaatuse register). Pakett ja imporditud tulemus kuvatakse siin.",
  "ltar.syy_a": "{n} avatud A-klassi punchi — paranda need või registreeri kõrvalekalle",
  "ltar.syy_edustaja": "Tellija esindaja on kohustuslik — liin käiakse läbi koos esindajaga",
  "ltar.syy_ei_tilaa": "Punchide olekut ei õnnestunud laadida — kinnitamine on blokeeritud, kuni see õnnestub",
  "ltar.syy_punchit": "{n} avatud punchi — paranda enne kinnitamist",
  "ltar.syy_tayta": "Täida kõik 9 punkti",
  "ltar.syy_tuleva": "Üleandmise kuupäev on tulevikus — liini ei saa ette üle anda",
  "ltar.tallenna": "Salvesta",
  "ltar.tallennus_virhe": "Salvestamine ebaõnnestus.",
  "ltar.tarkastaja": "Inspektor",
  "ltar.tunnistetieto": "Salvesta tuvastusandmed",
  "ltar.tunnistetieto_title": "Paranda inspektori nime, kuupäeva või märkusi — kinnitus säilib",
  "ndt.avaa": "NDT +",
  "ndt.avaa_title": "Registreeri keevise {nro} NDT tulemus",
  "nippu.aloittamaton": "rida masteris alustamata, kontrolli",
  "nippu.aloittamaton_yleinen": "rida alustamata, kontrolli",
  "nippu.avaa_seuraava": "Ava järgmine",
  "nippu.avoin_punch": "Avatud punch",
  "nippu.edellinen": "Eelmine",
  "nippu.ei": "ei",
  "nippu.ei_hitseja": "Liinil pole keeviseid.",
  "nippu.ei_isometria": "isomeetria puudub",
  "nippu.haku_esim": "Otsi: tunnus, keskkond või DN (nt APR 200)",
  "nippu.haku_virhe": "Laadimine ebaõnnestus.",
  "nippu.hitsattu": "keevitatud",
  "nippu.hitsit_virhe": "Keeviseid ei õnnestunud laadida.",
  "nippu.isometri": "Isomeetria",
  "nippu.isometri_pieni": "isomeetria",
  "nippu.joista_isometri": "neist isomeetriaga",
  "nippu.kaikki": "kõik",
  "nippu.kaikki_kasitelty": "kõik käsitletud",
  "nippu.ladataan_hitseja": "Keeviste laadimine…",
  "nippu.lataus_virhe": "Paketti ei õnnestunud laadida.",
  "nippu.linja": "Liin",
  "nippu.linja_id": "liin {id}",
  "nippu.lisatty": "{n} liini lisati paketti.",
  "nippu.lisays_virhe": "Paketti lisamine ebaõnnestus.",
  "nippu.minun": "Minu pakett",
  "nippu.ndt_ei": "NDT puudub",
  "nippu.ndt_hylatty": "NDT tagasi lükatud",
  "nippu.ndt_hyvaksytty": "NDT heaks kiidetud",
  "nippu.ndt_kesken": "NDT pooleli",
  "nippu.nippu": "Pakett",
  "nippu.nipussa": "paketis",
  "nippu.ohita": "Jäta vahele",
  "nippu.ohitettu": "vahele jäetud",
  "nippu.on": "jah",
  "nippu.on_isometri": "isomeetria olemas",
  "nippu.ota": "Võta pakett ({n})",
  "nippu.poista": "eemalda",
  "nippu.poista_aria": "Eemalda {tunnus} paketist",
  "nippu.prosessi": "protsess",
  "nippu.seuraava": "Järgmine",
  "nippu.seuraava_pieni": "järgmine",
  "nippu.suunniteltu": "planeeritud",
  "nippu.syy_a_punchit": "{n} avatud A-klassi punchi",
  "nippu.syy_ei_hitseja": "liinil pole keeviseid",
  "nippu.syy_ei_valittuja": "Vali kõigepealt loendist liinid.",
  "nippu.syy_estavat": "{n} blokeerivat puudust",
  "nippu.syy_hitsaamatta": "{n} keevist keevitamata",
  "nippu.syy_numeroton": "{n} numbrita rida kuupäeva või keevitajaga — parandada masteris",
  "nippu.syy_numeroton_yleinen": "{n} numbrita rida kuupäeva või keevitajaga — paranda keeviste loendis",
  "nippu.syy_rt": "RT parandus avatud, keevis {hitsit}",
  "nippu.syy_tarkastettu": "juba üle vaadatud",
  "nippu.tarra": "silt",
  "nippu.tehty": "Tehtud",
  "nippu.tehty_pieni": "tehtud",
  "nippu.tila": "Olek",
  "nippu.tyhja": "Pakett on tühi. Vali liinid loendist «Valmis liini ülevaatuseks».",
  "nippu.v_hitsit": "Keevised",
  "nippu.v_tarkastus": "Ülevaatus",
  "nippu.vain_valmiit": "ainult valmis",
  "nippu.valitse_kaikki": "Vali kõik nähtavad valmis liinid ({n})",
  "nippu.valitse_linja": "Vali {tunnus}",
  "nippu.valmiit": "Valmis liini ülevaatuseks",
  "nippu.valmiita": "Valmis liini ülevaatuseks",
  "nippu.valmis": "valmis",
  "nippu.valmis_maaritelma": "Valmis = kõik keevised keevitatud, pole avatud A-klassi punchi ega blokeerivat puudust, veel üle vaatamata. NDT ei ole tingimus (liini ülevaatus enne NDT-d).",
  "omat.ei_henkiloa": "Sinu kasutajakontoga pole seotud ühtegi isikut. Võta ühendust administraatoriga.",
  "omat.ei_patevyyksia": "Kvalifikatsioone pole registreeritud.",
  "omat.ei_tehtavia": "Sa ei tegele praegu ühegi puuduse ega punchiga.",
  "omat.ei_tyomaata": "Sa ei näe ühtegi objekti: {syy}. Objektid jagab töödejuhataja.",
  "omat.ei_vanhene": "ei aegu",
  "omat.haku_virhe": "Sinu andmeid ei õnnestunud laadida.",
  "omat.hitsausloki_piilossa": "Keevituspäevikut ei kuvata, sest sinu isikukirjel pole keevitusega seotud ametit (näiteks keevitaja, torumontöör (keevitus) või töödejuhataja). Administraator lisab selle isikukaardile.",
  "omat.ohje.kuka": "Igaüks näeb oma andmeid ja ainult neid. Vaade on ainult lugemiseks: parandusi (kontaktandmed, kvalifikatsioonid) teeb töödejuhataja või administraator.",
  "omat.ohje.luvut": "Kvalifikatsiooni olek tuleb selle kehtivusest: aegunud, aegub 30 päeva jooksul, aegub 90 päeva jooksul, kehtiv või ei aegu. ✓ nime ees tähendab, et sertifikaat on lisatud. Objekt tuletatakse sinu tööjaotusest 30 päeva piires.",
  "omat.oma_profiili": "Minu profiil",
  "omat.osaamiset": "Oskused",
  "omat.puhelin": "Telefon",
  "omat.tehtava_punch": "Punch",
  "omat.tehtava_puute": "Puudus",
  "omat.tehtavat": "Minu ülesanded",
  "omat.tehtavat_laji": "Näita",
  "omat.tehtavat_punchit": "ainult punchid",
  "omat.tehtavat_puutteet": "ainult puudused",
  "omat.tyosuhde": "Töösuhe",
  "pc.avaa": "Ava uuesti",
  "pc.ei_kuvia": "fotosid pole",
  "pc.ei_puncheja": "Punche pole.",
  "pc.hitsi_pieni": "keevis",
  "pc.huomioinut": "Märkas",
  "pc.huomioinut_oletus": "Märkas (vaikimisi: sina)",
  "pc.huomiopaiva": "Märkamise kuupäev (vaikimisi: täna)",
  "pc.korjattu": "Parandatud",
  "pc.korjattu_pieni": "parandas",
  "pc.korjatut": "Parandatud ({n})",
  "pc.kuvaa_vika": "Kirjelda viga.",
  "pc.kuvat_title": "Punchi fotod ja manused",
  "pc.lataus_virhe": "Laadimine ebaõnnestus.",
  "pc.lisaa": "Lisa punch",
  "pc.luokka_title": "Takistusklass: mida selle tõttu teha ei saa",
  "pc.luokka.A": "takistab survekatset",
  "pc.luokka.B": "takistab isoleerimist",
  "pc.luokka.C": "ei takista midagi",
  "pc.maar.A": "korgid keevitamata · tihendid puudu · kalded valed · äärikud kontrollimata",
  "pc.maar.B": "torukinnitused pingutamata · äärikute pingutamine · maanduskaablid · küttekaabel",
  "pc.maar.C": "värvi parandus — liin võib juba kasutusel olla",
  "pc.mika_vika": "Mis viga…",
  "pc.n_avoinna": "{n} avatud",
  "pc.otsikko": "Punchide loend",
  "pc.sulje_kuvat": "Sulge fotod",
  "pc.tallenna": "Salvesta",
  "pc.valitse_luokka": "vali takistusklass",
  "pc.valitse_luokka_virhe": "Vali takistusklass: mida see punch takistab (A survekatse · B isoleerimine · C mitte midagi).",
  "pc.vastuu": "Vastutaja (kes parandab)",
  "pc.vastuu_lyhyt": "Parandaja",
  "ptk.anna_numero": "Protokolli lisamiseks sisesta protokolli number. Manus kuulub numbrile ja kuvatakse igal selle numbriga keevisel.",
  "ptk.arkistoi": "Arhiveeri",
  "ptk.liitteita": "{nro}: {n} manust",
  "ptk.lisaa": "Lisa protokoll",
  "ptk.lisaa_sivu": "Lisa lehekülg",
  "ptk.numeron_liitteet": "Protokoll {nro} (kõik selle numbriga keevised)",
  "ptk.otsikko": "Protokoll (foto/PDF)",
  "pu.aloitettu": "Alustatud",
  "pu.avaa_uudelleen": "Ava uuesti",
  "pu.ehdotus_title": "Kinnitab registris kirjapildi «{asu}» kui {nimi}. Allika rida ei muudeta.",
  "pu.ei_puutteita": "Nende filtritega puudusi pole.",
  "pu.kentta_tyhja": "Sul pole avatud puudusi. Sinu liinide punchid on liini lehel.",
  "pu.haku_virhe": "Otsing ebaõnnestus.",
  "pu.havaittu": "Tuvastatud",
  "pu.hylatty_kerran_title": "Sama puudus on varem korra tagasi lükatud.",
  "pu.hylatty_monta_title": "Isik on selle mitu korda tagasi lükanud ja automaatika tõstab selle ikka üles. Reegel on tõenäoliselt vale.",
  "pu.hylatty_n": "tagasi lükatud {n}× varem",
  "pu.hylkaa": "Lükka tagasi",
  "pu.hyvaksy_ehdotus": "Nõustu soovitusega: {nimi}",
  "pu.jonosta_pois": "jäetud järjekorrast välja",
  "pu.kaikki": "Kõik",
  "pu.kaikki_kohteet": "Kõik objektid",
  "pu.katkaistu": "loend näitab {n} vanimat / kiireloomulisemat",
  "pu.kattavuus_otsikko": "Tuvastusreeglite kaetus ({n} reeglit)",
  "pu.kattavuus_selite": "Reegel, mis tabab kõike, ei erista midagi: see on kaetuse arv, mitte leid. Read säilivad.",
  "pu.kerro_mika": "Kirjelda lühidalt, mis on valesti.",
  "pu.kirjaa": "Registreeri",
  "pu.kirjaa_havainto": "Registreeri puudus",
  "pu.kohde": "Objekt",
  "pu.kuittasi": "kinnitas {nimi}",
  "pu.kuittasi_title": "Isik kinnitas selle.",
  "pu.kuvat": "Fotod",
  "pu.kuvat_title": "Puuduse fotod ja manused",
  "pu.linja_valinnainen": "Liin (valikuline)",
  "pu.linjaa_ei_loydy": "Liini {linja} pole valitud objektil. Vali loendist või jäta tühjaks.",
  "pu.luku.avointa": "avatud",
  "pu.luku.pysayttaa": "peatab töö",
  "pu.luku.rivia": "rida",
  "pu.luku.ulkoisia": "välist",
  "pu.mika_pielessa": "Mis on valesti",
  "pu.mika_pielessa_esim": "Nt liini 3 mõõtjoonis puudub",
  "pu.mita": "Mis",
  "pu.muutos_virhe": "Muutmine ebaõnnestus.",
  "pu.ohje.kuka": "Igaüks, kes näeb objekti, saab puuduse registreerida ja märkida alustatuks, lahendatuks või tagasi lükatuks või uuesti avada — objektil registreeritud puudus kehtib samamoodi kui töödejuhataja oma. Kes ja millal lahendas, salvestatakse. Objektidele piiratud konto näeb ainult oma objektide puudusi ega näe kunagi isikuid puudutavaid puudusi. Fotosid saavad lisada administraator, planeerija, töödejuhataja ja välitöötaja; kustutada saavad ainult administraator ja planeerija. Nimesoovituse kinnitab administraator, planeerija või töödejuhataja. Välitöötaja ei näe välise osapoole nime.",
  "pu.ohje.luvut": "Ülaosa arvud loevad kõiki filtrile vastavaid ridu, mitte ainult loendis olevaid. Automaatselt tuvastatud puudused luuakse öisel käivitusel; käsitsi registreeritud ilmuvad kohe. «N p» loeb tuvastamisest, seega on probleem vähemalt nii vana. Suletud puudus jääb alles: kui põhjus on endiselt olemas, ilmub see uuesti uue reana ja «tagasi lükatud N× varem» ütleb, mitu korda sama puudus on tagasi lükatud. Kaetus näitab, millist osa punktidest reegel tabab; reegel, mis tabab kõike, ei erista midagi ja jäetakse järjekorrast välja — read säilivad siiski.",
  "pu.ratkaistu": "Lahendatud",
  "pu.saanto": "Reegel",
  "pu.saanto_pois": "Tühjenda reegli filter",
  "pu.saanto_sulki": "suletud reegliga (ilma kinnituseta)",
  "pu.saanto_sulki_title": "Reegel sulges selle ise (nt objekt lõpetas võimsuse broneerimise) — kinnitust pole ega oodatagi.",
  "pu.tallennetaan": "Salvestamine…",
  "pu.tarkista_saanto": "kontrolli reeglit",
  "pu.tila": "Olek",
  "pu.tila.avoimet": "Avatud",
  "pu.tila.hylatyt": "Tagasi lükatud",
  "pu.tila.kaynnissa": "Pooleli",
  "pu.tila.ratkaistut": "Lahendatud",
  "pu.tila.vain_avoin": "Ainult avatud",
  "pu.tyhja_koko_kohde": "tühi = kogu objekt",
  "pu.tyyppi": "Tüüp",
  "pu.ulkoinen_vastuu": "Väline vastutus (tuleb nõuda, võimalik arveldada)",
  "pu.vahvistus_virhe": "Kinnitamine ebaõnnestus.",
  "pu.vaikutus": "Mõju",
  "pu.valitse_kohde": "Vali objekt.",
  "pu.vastuu": "Vastutaja",
  "pu.vastuu_esim": "töödejuhtimine, projekteerimine…",
  "pu.vastuu_suodatin.ei": "Vastutust pole registreeritud",
  "pu.vastuu_suodatin.muu": "Muu (kirjutatud)",
  "pu.vastuu_suodatin.sisainen": "Oma vastutus (mitte väline)",
  "pu.vastuu_suodatin.suunnittelu": "Projekteerimine",
  "pu.vastuu_suodatin.tyonjohto": "Töödejuhtimine",
  "pu.vastuu_suodatin.ulkoinen": "Väline vastutus",
  "pu.vrk": "{n} p",
  "puute.k.dn_epaselva": "DN ebaselge: suurus {koko} ei ole nimimõõt ega standardne välisläbimõõt ja liini {linja} nimes pole suurust — keevis {nro} ei saa läbimõõdu tolle",
  "puute.k.henkilo": "{kentta}: tundmatu nimi «{asu}»",
  "puute.k.henkilo_ehdotus": "{kentta}: tundmatu nimi «{asu}» — soovitus: {ehdotus} (kinnitada)",
  "puute.k.hitsaaja_tuntematon": "Keevitajat ei tunta ära: kood {koodi} ({hitsi})",
  "puute.k.hitsinumero_epaselva": "Keevise number ebaselge: «{nro}» liinil {linja} ei ole number ega alamnumber (N või N.N)",
  "puute.k.hitsinumero_puuttuu": "Keevise number puudub: liinil {linja} (leht {lehti}) on keevitatud keevis ilma numbrita — keevist ei saa tuvastada",
  "puute.k.hitsisuunnitelma_puuttuu": "Keevitusplaan puudub: {linja} ({n} keevist registreeritud)",
  "puute.k.isometri_puuttuu": "Isomeetria puudub: {linja}",
  "puute.k.kalusto_katsastus": "{laite}: tehniline ülevaatus aegub",
  "puute.k.korjaus_orpo": "Paranduskeevis ilma algse keeviseta: {hitsi}",
  "puute.k.materiaali_puuttuu": "Keevisel {hitsi} puudub materjal",
  "puute.k.ndt_poytakirja_puuttuu": "NDT protokoll puudub: liinil {linja} on {n} NDT tulemust ilma inspektori või protokolli numbrita",
  "puute.k.paiva_jasentymaton": "Keevituse kuupäeva ei saa lugeda: {hitsi} — allikas {raaka}",
  "puute.k.patevyys_kesken": "{nimi}: {patevyys} aegub, tööd on jaotatud pärast seda",
  "puute.k.patevyys_vanhenee": "{nimi}: {patevyys} aegub",
  "puute.k.patevyys_vanhenee_pvm": "{nimi}: {patevyys} aegub {pvm}",
  "puute.k.perehdytys": "{nimi}: objekti sissejuhatus puudub ({kohde})",
  "puute.k.sulatus_puuttuu": "Keevisel {hitsi} puudub sulami number",
  "puute.k.tarra_normalisointi": "Silt normaliseeriti kujule {muoto}: «{raaka}» ({lahde}) → {tallennettu} ({peruste}). Kontrollige allikat.",
  "puute.k.tyhja": "(tühi)",
  "puute.k.painekoe_valine": "{linja}: survekatse {pvm} kinnitatud ilma mõõteseadmeta (katserõhk / hoideaeg / seade puudub)",
  "puute.k.painekoe_kalibrointi": "{linja}: survekatse {pvm} mõõteseadmega, mille kalibreering oli aegunud ({asti}) — tulemus ei kehti",
  "puute.k.kalusto_ehdotus_kohde": "{laite}: välitöötaja pakutud seade ootab seadmete vastutaja kinnitust (objekt {kohde})",
  "puute.k.kalusto_ehdotus": "{laite}: välitöötaja pakutud seade ootab seadmete vastutaja kinnitust",
  "puute.k.iv_tiiviys": "{kohta}: lekkekatse ebaõnnestus — lekkeõhuvool {vuoto} dm³/s > piir {raja} dm³/s (klass {luokka}, {paine} Pa)",
  "puute.k.iv_ilmavirta": "{kohta}: õhuvool väljaspool tolerantsi — hälve {poikkeama} % > tolerants ±{toleranssi} % (projekteeritud {suunniteltu} l/s, mõõdetud {mitattu} l/s)",
  "puute.k.iv_kal_tiiviys": "{kohta}: lekkekatse {pvm} mõõteseadmega {laite} — seadme kalibreering ei kehtinud mõõtmise päeval (kehtis kuni {asti})",
  "puute.k.iv_kal_tiiviys_ei": "{kohta}: lekkekatse {pvm} mõõteseadmega {laite} — seadme kalibreering ei kehtinud mõõtmise päeval (kalibreering puudub)",
  "puute.k.iv_kal_ilmavirta": "{kohta}: õhuvoolu mõõtmine {pvm} mõõteseadmega {laite} — seadme kalibreering ei kehtinud mõõtmise päeval (kehtis kuni {asti})",
  "puute.k.iv_kal_ilmavirta_ei": "{kohta}: õhuvoolu mõõtmine {pvm} mõõteseadmega {laite} — seadme kalibreering ei kehtinud mõõtmise päeval (kalibreering puudub)",
  "puute.k.paiva_puuttuu": "kuupäev puudub",
  "puute.k.ei_kalibrointia": "kalibreering puudub",
  "qr.lisays_virhe": "Lisamine ebaõnnestus.",
  "qr.muokkaa": "Muuda",
  "sal.ei_lahetysta": "E-postiga saatmine pole võimalik: {syy}.",
  "sal.ei_osoitetta": "saajal pole e-posti aadressi",
  "sal.kaikki_kopioitu": "Kõik kopeeritud",
  "sal.kopioi": "Kopeeri",
  "sal.kopioi_kaikki": "Kopeeri kõik",
  "sal.kopioitu": "Kopeeritud",
  "sal.laheta_sahkopostilla": "Saada e-postiga: {osoite}",
  "sal.lahetetaan": "Saatmine…",
  "sal.lahetettiin_alku": "Link saadeti aadressile",
  "sal.lahetettiin_loppu": ". Seda näidatakse siin ainult praegu.",
  "sal.lahetys_virhe": "Saatmine ebaõnnestus.",
  "sal.sulje_kopioimatta": "Sa pole väärtust veel kopeerinud. Kui selle sulged, ei saa seda enam kuskilt kätte — kas sulgeda ikkagi?",
  "sal.tallennettu_sulje": "Olen selle salvestanud — sulge",
  "sal.tulosta": "Prindi",
  "sal.vain_nyt": "Näidatakse ainult praegu. Kui selle sulged, ei saa väärtust enam kuskilt kätte.",
  "sel.alinumero_ilman_esitysta": "Alamnumber ilma ettepanekuta (registreeritud enne 153) — saab endiselt kinnitada.",
  "sel.alinumero_virhe": "Lisakeevise number on oma ülemkeevise {kanta} alamnumber, nt {kanta}.1. «{nro}» ei ole selline.",
  "sel.asemassa": "Rollis",
  "sel.asetettu_hyvaksyja": "määratud kinnitaja",
  "sel.avoimia_puncheja": "avatud punchi",
  "sel.ehdotus_virhe": "Soovitust ei õnnestunud saada.",
  "sel.ei_hitseja": "Registreeritud keeviseid pole.",
  "sel.ei_linjoja": "Liine pole.",
  "sel.ei_ndt_vaatimusta": "Toruklassile {luokka} pole NDT nõuet registreeritud — kaetust ei saa arvutada.",
  "sel.ei_numeroa": "numbrita",
  "sel.ei_ped_luokkaa": "Liinile pole PED kategooriat registreeritud, seega nõuet ei saa leida.",
  "sel.ei_punakynaa": "Selle keevise kohta pole punase pliiatsi märget registreeritud.",
  "sel.ei_puutteita": "Selle liini kohta pole puudusi registreeritud. Registreerimiseks: Puudused → «Registreeri puudus» → Liin.",
  "sel.ei_riita_luovutukseen": "üleandmiseks ei piisa",
  "sel.ei_tarkastuksia": "Kontrolle pole registreeritud.",
  "sel.ei_tehda_title": "Märgi, et keevisõmblust ei tehta üldse, kuigi seda pole loendis. Loob rea ja reserveerib numbri.",
  "sel.ei_toteudu": "Pole vajalik",
  "sel.ei_toteudu_placeholder": "nt liin sirgendatud, haru ära jäetud",
  "sel.ei_toteudu_title": "Märgi, et keevist {nro} ei tehta. Rida jääb päevikusse ja jäetakse kaetuse arvutusest välja; põhjendus on kohustuslik ja märke saab tühistada.",
  "sel.ei_toteudu_vihje": "Märge ootab kinnitust: rida jääb päevikusse ja langeb kaetuse arvutusest välja alles siis, kui kinnitaja (välitöö juhataja või määratud kinnitaja) kinnitab selle punase pliiatsi all. Tagasi lükatud märge taastab rea.",
  "sel.ei_vahvistettavia": "Kinnitust ootavaid pole.",
  "sel.ei_valittu": "valimata",
  "sel.emo": "ülemkeevis",
  "sel.haku_placeholder": "Otsi: tunnus, keskkond või DN (nt APR 200)",
  "sel.historia_virhe": "Ajalugu ei õnnestunud laadida.",
  "sel.hitsattu_nyt": "Keevitatud nüüd — registreeritud tänasele",
  "sel.hitsi_ei_toteudu": "Keevis {nro} pole vajalik",
  "sel.hitsinumero": "Keevise number",
  "sel.hylkaa_ellipsi": "Lükka tagasi…",
  "sel.hylkaa_poisto": "Lükka tagasi — keevis jääb",
  "sel.hylkayksen_peruste": "Tagasilükkamise põhjus (kohustuslik)",
  "sel.hylkays_placeholder": "miks muudatus tagasi lükatakse",
  "sel.hylkays_virhe": "Tagasilükkamine ebaõnnestus.",
  "sel.hyvaksyn_asemassa": "Kinnitan rollis",
  "sel.isometri_olemassa": "Isomeetria on olemas",
  "sel.kaikki_linjat": "Kõik liinid",
  "sel.kaikki_punchit": "Kõik punchid",
  "sel.kelpaa_luovutukseen": "kehtib üleandmiseks",
  "sel.kirjattu_ei_toteudu": "Registreeritud — {nro} pole vajalik",
  "sel.kirjattu_lisa": "Registreeritud — lisakeevis {nro}",
  "sel.kohde_peruuntunut": "Objekt {kohde} on tühistatud. Sellele liinile ei saa keeviseid, kontrolle ega punche registreerida.",
  "sel.korvattu": "Liini tunnus {vanha} asendati tunnusega {uusi} ({miten}, tuvastatud {pvm}). Suunati uuele tunnusele.",
  "sel.kuvat_hitsi": "Fotod · keevis {nro}",
  "sel.kuvat_n": "fotod ({n})",
  "sel.kuvia_n": "fotosid {n}",
  "sel.lahde_ratkaisi": "lahendatud allikas",
  "sel.laheta_poistoesitys": "Saada kustutamistaotlus",
  "sel.laji": "Liik",
  "sel.laji_s": "Lisakatse",
  "sel.lehdella": "lehel {lehti}",
  "sel.linja_poistettu": "Liin {tunnus} on kasutusest kõrvaldatud ja sellel pole asendajat.",
  "sel.linjaa": "liini",
  "sel.linjaa_ei_loydy": "Liini {tunnus} ei leitud — seda pole olemas või see kuulub objektile, mida sa ei näe.",
  "sel.linjan_puutteet": "Liini puudused ({n})",
  "sel.linjan_puutteet_suljetut": "Suletud ({n})",
  "sel.linjat_esto": "Vali enne importimist allpool objekt — liinid imporditakse üks objekt korraga.",
  "sel.linjat_otsikko": "Liinid Excelist",
  "sel.linjat_paivitys": "Uuenda ka olemasolevaid liine ülal loetletud erinevuste järgi",
  "sel.linjat_selite": "Laadi mall alla, täida liinid ja impordi. Liinid luuakse allpool valitud objektile. Olemasolevaid ei muudeta, kui sa ei märgi uuendamist eraldi; proovikäivitus näitab enne salvestamist, mis luuakse, mis muutuks ja millised read lükatakse tagasi.",
  "sel.lisaa_hitsi": "+ keevis",
  "sel.lisaa_hitsi_title": "Lisa uus keevis numbri {nro} järele alamnumbriga (nt {nro}.1). Objektil tehtud lisandus, mis ootab töödejuhataja kinnitust.",
  "sel.lisaa_nro": "Lisa {nro} — ootab kinnitust",
  "sel.lisaa_suunniteltuna": "Lisa {nro} planeerituna — ootab kinnitust",
  "sel.lisahitsi_nro": "Lisakeevis {nro}",
  "sel.lisays_virhe": "Lisamine ebaõnnestus.",
  "sel.lue_lisaa": "Loe edasi",
  "sel.merkinta_virhe": "Märget ei õnnestunud salvestada.",
  "sel.merkitse_odottaa": "Märgi — ootab kinnitust",
  "sel.miksi_ei_tehda": "Miks keevisõmblust ei tehta",
  "sel.miksi_poistetaan": "Miks keevis kustutatakse?",
  "sel.miksi_tarvitaan": "Miks seda keevist on vaja",
  "sel.monta_osumaa": "Liini tunnus {tunnus} on olemas {n} objektil. Vali liin loendist.",
  "sel.muokkaa_linjaa": "Muuda liini",
  "sel.n_hitsia": "{n} keevist",
  "sel.naytetaan": "näidatakse {n}",
  "sel.ndt_esto": "Vali enne importimist allpool objekt — nõuded imporditakse üks objekt korraga.",
  "sel.ndt_hylatty": "tagasi lükatud",
  "sel.ndt_hyvaksytty": "heaks kiidetud",
  "sel.ndt_ja_painekoe": "NDT ja survekatse",
  "sel.ndt_kattavuus": "NDT kaetus",
  "sel.ndt_kesken": "pooleli",
  "sel.ndt_otsikko": "NDT nõuded Excelist",
  "sel.ndt_selite": "Objekti NDT nõuded PED kategooria ja meetodi järgi. Liini NDT kaetus arvutatakse nende järgi — ilma nõueteta ei arvuta kaetus midagi. Nõuded imporditakse allpool valitud objektile; olemasolevaid ei muudeta.",
  "sel.ndt_vaje": "NDT puudujääk",
  "sel.ndt_vaje_teksti": "liin ei ole survekatseks valmis. Täienda kontrolle enne survekatset; tehtud survekatse registreerimine nõuab nüüd põhjendust ja põhjendus jääb reale.",
  "sel.nro": "Nr",
  "sel.numero_tarkastettava": "kontrolli numbrit",
  "sel.numero_tarkastettava_ohje": "Keevise number on kohatäide («00», «?») või võrdub liini numbriga — kontrolli seda allikast.",
  "sel.odottaa_vahvistusta": "Ootab kinnitust",
  "sel.ohje_kuka": "Sirvimist näevad kasutajad, kellel on keevituspäevik kasutusel; välitöötajad ainult keevitusametiga ja objektidele piiratud kontod ainult oma objekte. Keeviseid parandavad administraatorid, planeerijad ja töödejuhatajad ning välitöötajad oma ja oma paarilise keeviseid 24 tunni jooksul registreerimisest. Liini muutmine, survekatse, punchid ja Exceli ringkäik: administraator, planeerija ja töödejuhataja. Keeviste ja manuste kustutamine ning impordid: administraator ja planeerija. Objektil tehtud muudatuse kinnitab punase pliiatsi kinnitusõiguse omanik.",
  "sel.ohje_luvut": "Liini «X / Y» on liini keeviseread (planeeritud kaasa arvatud) ja planeeritud keeviste arv. Punchi arv on avatud punchid. Keeviste loend näitab kuni 500 viimati registreeritut. NDT kaetus on kontrollitud keevised (heaks kiidetud või tagasi lükatud) võrreldes keevitatute nõutud osaga; tühi tähendab, et nõuet pole registreeritud — mitte et see on täidetud. «~» kuupäeva juures tähistab hinnangulist kuupäeva.",
  "sel.osa_nimike": "Detaili {n} nimetus",
  "sel.osa_sulatus": "Detaili {n} sulami nr",
  "sel.osat_sulatus": "Detailid (sulami nr)",
  "sel.otsikko_kaikki": "Kõik liinid · {n} keevist",
  "sel.otsikko_vahvistettavat": "Ootab kinnitust · {n} muudatust",
  "sel.ped_luokka": "PED kategooria",
  "sel.peru_hyvaksynta": "Tühista kinnitus",
  "sel.peru_tama": "Tühista see",
  "sel.peruttu": "tühistatud",
  "sel.peruutuksen_perustelu": "Tühistamise põhjus",
  "sel.peruutus_placeholder": "nt kinnitatud vale keevise kohta",
  "sel.peruutus_vaatii": "Tühistamine nõuab põhjendust",
  "sel.peruutus_virhe": "Tühistamine ebaõnnestus.",
  "sel.pk_ei_toteudu": "Pole vajalik — kinnitatud",
  "sel.pk_ei_toteudu_esitys": "Pole vajalik — ettepanek",
  "sel.pk_esitys": "Lisakeevis — ettepanek",
  "sel.pk_hylkays": "Tagasi lükatud",
  "sel.pk_lisays": "Lisakeevis — kinnitatud",
  "sel.pk_peruutus": "Tühistamine",
  "sel.pk_vihje": "Punane pliiats on kinnitus: muudatus tehti rea enda toiminguga («+ keevis» või «Pole vajalik») ja siin kinnitatakse või lükatakse see põhjendusega tagasi. Tagasi lükatud lisakeevis jääb reale olekuga «tagasi lükatud»; tagasi lükatud «pole vajalik» taastab rea. «Pole vajalik» ei kustuta keevist: rida jääb otsuse kirjeks ja langeb NDT kaetuse nimetajast välja alles pärast kinnitamist.",
  "sel.pk_vihje_heti": "kehtib kohe",
  "sel.pk_vihje_loppu": ", ja töö selle pärast ei peatu. Otsus läheb üleandmisdokumentatsiooni kinnitatuna ainult määratud kinnitajalt — see on teine küsimus kui «kas seda tohib otsustada».",
  "sel.pk_vihje_lyhyt": "Punane pliiats kinnitab või lükkab põhjendusega tagasi rea enda toiminguga («+ keevis» või «Pole vajalik») tehtud muudatuse. Töödejuhataja kinnitus kehtib kohe; otsus läheb üleandmisdokumentatsiooni kinnitatuna ainult määratud kinnitajalt.",
  "sel.pk_vihje_tj": "Töödejuhataja kinnitus",
  "sel.poisto_esitys_vihje": "Keevist ei kustutata kohe: taotlus läheb kinnitamiseks töödejuhatajale või administraatorile ja ilmub loendisse «Ootab kinnitust». Imporditud, kinnitatud või kontrollitud keevist ei kustutata — kasuta «Ei tehta».",
  "sel.poisto_hylkays_peruste": "Tagasilükkamise põhjus (kohustuslik ainult tagasilükkamisel)",
  "sel.poisto_ratkaisu_vihje": "Kinnitamine kustutab keevise ja taotlus jääb koos andmetega alles. Oma taotlust kinnitada ei saa.",
  "sel.poisto_virhe": "Kustutamistaotluse käsitlemine ebaõnnestus.",
  "sel.poytakirja": "Protokoll",
  "sel.punakyna": "Punane pliiats",
  "sel.punakyna_historia": "Punase pliiatsi ajalugu",
  "sel.punakyna_title": "Objektil tehtud muudatus: alamnumbriga lisakeevis või otsus, et keevisõmblust ei tehta",
  "sel.punch_lyh": "punch",
  "sel.putkiluokka": "Toruklass",
  "sel.pyyda_poistoa": "Taotle kustutamist",
  "sel.pyyda_poistoa_otsikko": "Taotle keevise {nro} kustutamist",
  "sel.ratkaise_poisto": "Kustutamistaotlus {nro}",
  "sel.sul_lyh": "Sulam",
  "sel.sulatus_taydennetty": "Sulami number lisatud hiljem",
  "sel.sulje_linjatiedot": "Sulge liini andmed",
  "sel.suunn_hitseja": "Planeeritud keevised",
  "sel.suunniteltu_myohemmin": "Planeeritud — registreeritakse keevitatuna, kui see on tehtud",
  "sel.t_ei_toteudu_hyvaksytty": "pole vajalik · kinnitatud",
  "sel.t_ei_toteudu_odottaa": "pole vajalik · ootab kinnitust",
  "sel.t_ei_toteudu_tyonjohto": "pole vajalik · töödejuhataja",
  "sel.t_lisa_hylatty": "lisakeevis · tagasi lükatud",
  "sel.t_lisa_hyvaksymatta": "lisakeevis · kinnitamata",
  "sel.t_lisa_hyvaksytty": "lisakeevis kinnitatud",
  "sel.t_poisto_odottaa": "Kustutamine ootab kinnitust",
  "sel.tallenna_linja": "Salvesta liin",
  "sel.tarra_korvattuja": "asendatud {n}",
  "sel.tarra_korvattuja_title": "Varasemad sildid säilivad ajaloona; asendatud silti ei kasutata kunagi uuesti.",
  "sel.tarra_title": "Füüsiline silt keevisõmbluse kõrval",
  "sel.tyonjohto_ei_riita": "töödejuhataja — üleandmiseks ei piisa",
  "sel.uusi_ei_listassa": "Uut tunnust pole sinu loendis — see kuulub objektile, mida sa ei näe.",
  "sel.otsikko_kaikki_rajattu": "Kõik liinid · kuvatakse {n} viimast / kokku {yht}",
  "sel.vaadittu_title": "nõutud {p} % · {kpl}/{yht}",
  "sel.vahvista": "Kinnita",
  "sel.vahvista_ei_toteudu": "Kinnita: {nro} pole vajalik",
  "sel.vahvista_lisa": "Kinnita: lisakeevis {nro}",
  "sel.vahvista_poisto": "Kinnita kustutamine",
  "sel.vahvista_title": "Kinnita või lükka tagasi keevise {nro} kohta objektil tehtud muudatus",
  "sel.vahvistettavat_virhe": "Kinnitust ootavaid muudatusi ei õnnestunud laadida.",
  "sel.vahvistuksen_perustelu": "Kinnitamise põhjus",
  "sel.vahvistus_placeholder": "nt isomeetria muudatus 12.9., haru nihutatud",
  "sel.vahvistus_virhe": "Kinnitamine ebaõnnestus.",
  "sel.valiin_otsikko": "Lisa keevis vahele",
  "sel.valiin_placeholder": "nt tugi nihutatud, liide lisatud 12.9.",
  "sel.valiin_selite": "Uus keevis tuleb numbri {nro}{lehti} järele.",
  "sel.valiin_vihje": "Keevis salvestatakse kohe ja ootab töödejuhataja kinnitust — see ei kao ega takista tööd. Põhjendus on lause, mida kinnitaja loeb.",
  "sel.valiin_vihje_suunniteltu": "Planeeritud lisakeevis kuvatakse välitöö registreerimisel planeerituna ja registreeritakse sealt keevitatuna; kui seda ei tehta, märgi see «Pole vajalik».",
  "sel.valitse_asema": "Vali roll",
  "sel.valitse_ohje": "Vali liin, \"Kõik liinid\", \"Kõik punchid\" või \"Ootab kinnitust\".",
  "sel.vanha_ei_hylata": "Vana alamnumbrit ilma ettepanekuta ei lükata tagasi — see kinnitatakse või kustutatakse.",
  "sel.wps_otsikko": "WPS loend Excelist",
  "sel.wps_selite": "Keevitusprotseduuri spetsifikatsioonid on ettevõtte ühine loend, millest keevise registreerimisel valitakse. Laadi mall alla, täida ja impordi; olemasolevaid ei muudeta.",
  "tk.poista": "Kustuta",
  "valikko.academy": "Academy",
  "valikko.ainestodistukset": "Materjalisertifikaadid",
  "valikko.asiakkaat": "Kliendid",
  "valikko.etenema": "Edenemine",
  // T646 (1) ja T514 (23.10.2026): työmaasanasto T09 «liini ülevaatus», T07 «survekatse» (C-luokka, tarkistamaton).
  "valikko.linjatarkastukset": "Liinide ülevaatused",
  "valikko.koeponnistusvalmius": "Survekatseks valmis",
  "valikko.henkilosto": "Personal",
  "valikko.hitsausloki": "Keevituspäevik",
  "valikko.iv_asennus": "Ventilatsiooni paigaldus",
  "valikko.portit": "Etapiväravad (TG)",
  "tg.selite": "Väravad on töövõtu kontrollpunktid hinnapäringust üleandmiseni. Värav kinnitatakse, kui selle ülesanded on tehtud. Väravat kinnitab ja selle tähtaega muudab ainult selleks õigustatud isik. Iga sündmus jääb logisse.",
  "valikko.kaannokset": "Tõlked",
  "valikko.kalusto": "Seadmed",
  "valikko.laiteasennus": "Seadmete paigaldus",
  "valikko.linjatarkastus": "Liini ülevaatus",
  "valikko.luovutusvalmius": "Üleandmisvalmidus",
  "valikko.materiaalit": "Materjalid",
  "valikko.mitoitus": "Dimensioneerimine",
  "valikko.odottaa_vahvistusta": "Ootab kinnitust",
  "valikko.omat_tiedot": "Minu andmed",
  "valikko.osaamisradat": "Oskuste rajad",
  "valikko.patevyydet": "Kvalifikatsioonid",
  "valikko.projekti_hub": "Projekti ülevaade",
  "valikko.puutteet": "Puudused",
  "valikko.puuttuvat_hitsit": "Puuduvad keevised",
  "valikko.resurssit": "Ressursid",
  "valikko.ryhma.kenttatyo": "Välitöö",
  "valikko.selailu": "Sirvi",
  "valikko.suunnitelma": "3 nädala plaan",
  "valikko.tarjoukset": "Pakkumised",
  "valikko.tarjousasetukset": "Pakkumise seaded",
  "valikko.tunnukset": "Kasutajakontod",
  "valikko.tuntikirjaus": "Tööaja arvestus",
  "valikko.tyokohteet": "Objektid",
  "valikko.tyopaketit": "Tööpaketid",
  "valikko.tyovuorot": "Vahetused",
  "valikko.varasto": "Ladu",
  "valikko.viestit": "Sõnumid",
  "valikko.yrityksen_tiedot": "Ettevõtte andmed",
  "virhe.ei_hoitajaa": "Keegi ei tegele selle reaga.",
  "virhe.ei_oikeutta_osoittaa": "Teise eest saab määrata ainult töödejuhataja või administraator.",
  "virhe.ei_oikeutta_vapauttaa": "Teise rea saab vabastada ainult töödejuhataja või administraator.",
  "virhe.ei_poisteta": "Tööpaketti ei kustutata — arhiveeri see.",
  "virhe.emo_moniselitteinen": "Ülemkeevis pole ühene: samal liinil ja lehel on selle numbriga mitu keevist.",
  "virhe.hitsi_eri_linjalla": "Keevis ei ole sellel liinil.",
  "virhe.hitsinumero_muoto": "Keevise numbrit ei aktsepteerita: kasuta numbrit või alamnumbrit (nt 12 või 12.1), kuni 6 numbrit enne punkti.",
  "virhe.hoitaja_ei_kelpaa": "Valitud konto ei näe seda rida või tal pole õigust järjekorrale.",
  "virhe.hoitaja_jo": "Keegi teine tegeleb juba selle reaga. Töödejuhataja saab selle ümber määrata.",
  "virhe.jo_arkistoitu": "Tööpakett on juba arhiveeritud.",
  "virhe.kieli_valitsematta": "Vali kõigepealt oma keel vaates Minu andmed — vaatad üle selle keele tõlked.",
  "virhe.kirjautuminen_epaonnistui": "Vale kasutajanimi või parool.",
  "virhe.kohde_peruuntunut": "Objekt on tühistatud — sellele ei saa midagi registreerida.",
  "virhe.korjattava_moniselitteinen": "Parandatav keevis pole ühene: selle numbriga on mitu keevist.",
  "virhe.korjaus_puuttuu": "Kirjuta parandatud tõlge.",
  "virhe.kysely_aikaraja": "Loend ei valminud 15 sekundi jooksul. Kitsenda otsingut või vali «ainult valmis».",
  "virhe.linjatarkastus_tuotu": "Liinil on juba SharePointist pärit ülevaatus. Korduv ülevaatus tuleb hiljem.",
  "virhe.ndt_tunnistetiedot_puuttuvat": "NDT tulemuseks on vaja inspektorit ja protokolli numbrit.",
  "virhe.tuntematon_kieli": "See keel pole saadaval.",
  "virhe.vieras_kieli": "Ülevaataja näeb ainult oma keele tõlkeid.",
  "vt.ei_hitsattu": "Keevitamata — VT-d ei saa registreerida",
  "vt.ei_loydy": "keevist ei leitud",
  "vt.hylatty": "Tagasi lükatud",
  "vt.hylatty_tila": "VT tagasi lükatud",
  "vt.hylkaa_title": "Keevise {nro} VT tagasi lükatud: vali viga",
  "vt.hylkays_otsikko": "VT tagasi lükatud, keevis {nro}",
  "vt.hyvaksy_title": "Keevise {nro} VT heaks kiidetud (üks puudutus)",
  "vt.hyvaksynta_otsikko": "VT heaks kiidetud, keevis {nro}",
  "vt.hyvaksytty": "Heaks kiidetud",
  "vt.ikkuna_otsikko": "VT registreerimine: {n} keevist",
  "vt.jo_kirjattu": "VT juba registreeritud",
  "vt.kirjaa_valituille": "Registreeri VT valitutele ({n})",
  "vt.kirjattu": "Registreeritud: {h} heaks kiidetud, {x} tagasi lükatud.",
  "vt.kirjattu_yksi": "VT heaks kiidetud: keevis {nro}",
  "vt.kuvaus": "Kirjeldus (valikuline)",
  "vt.kuvaus_pakollinen": "Kirjeldus (kohustuslik valiku «muu» korral)",
  "vt.ohitettu": "{n} vahele jäetud (juba registreeritud või keevitamata)",
  "vt.paiva": "Kuupäev",
  "vt.raportti": "Protokolli nr",
  "vt.raportti_pakollinen": "Protokolli number on kohustuslik.",
  "vt.sarake_title": "VT – visuaalne kontroll: vali hulgiregistreerimiseks või registreeri otse ✓ / ✗",
  "vt.tallenna": "Salvesta",
  "vt.tallenna_hylatty": "Salvesta tagasi lükatud VT",
  "vt.tallenna_hyvaksytty": "Salvesta heaks kiidetud VT",
  "vt.tarkastaja": "Inspektor",
  "vt.tyhjenna": "Tühjenda valik",
  "vt.valitse_kaikki": "Vali kõik keevitatud ilma VT-ta",
  "vt.valitse_title": "Vali VT hulgiregistreerimiseks",
  "vt.valitse_vika": "Vali vea liik",
  "vt.valittu": "{n} valitud",
  "vt.vika": "Vea liik",
  "vt.vika_puuttuu": "{n} tagasi lükatud ilma vea liigi või kirjelduseta",
  "vt.vika.halkeama": "Pragu",
  "vt.vika.huokonen": "Poorsus",
  "vt.vika.kupu": "Liigne kõrgendus",
  "vt.vika.muu": "Muu",
  "vt.vika.reunahaava": "Servasälk",
  "vt.vika.roiske": "Pritsmed",
  "vt.vika.vajaa_taytto": "Mittetäielik täitmine",
  "vt.virhe": "VT registreerimine ebaõnnestus.",
  "vt.yhteenveto": "{h} heaks kiidetud, {x} tagasi lükatud",
  "yleinen.ladataan": "Laadimine…",
  // 18.10.2026 (vikakoe 4): säännön nimet Hubin jonoon ja Puutteet-sivun sääntösiruun; termit tiedoston omasta virosta.
  "hub.saanto.paiva_jasentymaton": "kuupäev loetamatu",
  "hub.saanto.sulatus_puuttuu": "sulami number puudub",
  "hub.saanto.korjaus_orpo": "parandus ilma algse keeviseta",
  "hub.saanto.painekoe_valine": "survekatse: vahend",
  "hub.saanto.hitsisuunnitelma_puuttuu": "keevitusplaan puudub",
  "hub.saanto.perehdytys": "objekti sissejuhatus",
  "hub.saanto.materiaali_puuttuu": "materjal puudub",
  "hub.saanto.patevyys_vanhenee": "kvalifikatsioon aegub",
  "hub.saanto.patevyys_kesken": "kvalifikatsioon pooleli",
  "hub.saanto.kalusto_katsastus": "seadme tehniline ülevaatus",
  "hub.saanto.kalusto_ehdotus": "seadme ettepanek",
  "hub.saanto.hitsaaja_tuntematon": "keevitaja tundmatu",
  "hub.saanto.isometri_puuttuu": "isomeetria puudub",
  "hub.saanto.iv_ilmavirta": "ventilatsioon: õhuvool",
  "hub.saanto.iv_tiiviys": "ventilatsioon: tihedus",
  "hub.saanto.iv_kalibrointi_i": "ventilatsioon: kalibreerimine (õhuvool)",
  "hub.saanto.iv_kalibrointi_t": "ventilatsioon: kalibreerimine (tihedus)",
  "hub.saanto.henkilo": "isik",
  "hub.saanto.tarra-normalisointi": "kleebise normaliseerimine",
  "hub.saanto.dn_epaselva": "DN ebaselge",
  "hub.saanto.hitsinumero_puuttuu": "keevise number puudub",
  "hub.saanto.hitsinumero_epaselva": "keevise number ebaselge",
  "hub.saanto.muoviputki_epaily": "keevis plasttorul?",
  "hub.saanto.ndt_poytakirja_puuttuu": "NDT protokoll puudub",
  "hub.saanto.ped_iv_sweco": "PED/ventilatsioon (projekteerija)",
  // 250 (Toni 19.10.2026): liitteen laji
  "liite.laji_valinta": "Liik",
  "liite.laji_tavallinen": "Foto või muu manus",
  "liite.laji.allekirjoitettu_poytakirja": "Allkirjastatud protokoll",
  "liite.laji.allekirjoitus": "Allkiri",
  "liite.galleriasta": "Vali galeriist",
  "isom.lisaa_valokuva": "Lisa foto",
  // 251 (T621, Toni 19.10.2026)
  "ltar.allekirjoitus": "Tellija esindaja allkiri",
  "ltar.allekirjoita_ohje": "Allkirjasta sõrme või pliiatsiga",
  "ltar.tyhjenna": "Tühjenda",
  "ltar.syy_allekirjoitus": "Tellija esindaja allkiri puudub — joonista allkiri või lisa allkirjastatud protokoll",
  "ltar.allekirjoitettu": "Allkirjastanud {nimi} · {aika}",
  "ltar.paperi_liitteena": "Allkirjastatud protokoll lisatud ({n})",
  "ltar.tarkastuskuvat": "Ülevaatuse fotod",
  "ltar.lisaa_tarkastuskuva": "Lisa ülevaatuse foto",
  "ltar.tarkastuskuva_vihje": "Fotonupp avab kaamera. Allkirjastatud paberprotokolli saab lisada liigiga «Allkirjastatud protokoll».",
  "virhe.linjatarkastus_kohdat_kesken": "Enne kinnitamist tuleb täita kõik 9 punkti.",
  "virhe.linjatarkastus_allekirjoitus_puuttuu": "Tellija esindaja allkiri puudub: joonista allkiri või lisa allkirjastatud protokoll.",
  "virhe.ei_hyvaksyntaoikeutta": "Väravat saab kinnitada ainult isik, kellel on sellele objektile õigus „Approve a gate“.",
  "virhe.ei_siirto_oikeutta": "Tähtaega saab nihutada ainult isik, kellel on sellele objektile õigus „Move a gate deadline“.",
  "virhe.portti_lukittu": "Väravad on lukus: varasemate väravate ülesanded on pooleli.",
  "virhe.tehtavia_kesken": "Väravatel on tegemata ülesandeid.",
  "virhe.jo_hyvaksytty":"Väravad on juba kinnitatud.",
  "virhe.sama_paiva": "Uus tähtaeg on sama kui praegune.",
  "virhe.ulkopuolinen_tarvitsee_kohteen":"Väline konto luuakse alati objektile. Valige vähemalt üks objekt.",
  "virhe.vt_peruste_puuttuu":"Mõnel keevisel puudub VT. Punkti 7.2 saab märkida OK-ks ainult põhjendusega.",
  "virhe.linjatarkastus_lukittu": "Kinnitatud liini ülevaatuse allkirja ei muudeta.",
  "virhe.allekirjoitus_tyhja": "Allkiri on tühi.",
};
